import React from 'react';
import './HeroSection.css';

function HeroSection() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <svg className="hero-illustration hero-illustration-left" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="100" r="80" fill="rgba(255,255,255,0.1)" />
        <path d="M100,40 Q120,60 100,80 Q80,60 100,40" fill="rgba(255,255,255,0.2)" />
        <circle cx="100" cy="100" r="60" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="2" />
        <path d="M70,100 Q100,70 130,100" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="3" strokeLinecap="round" />
      </svg>

      <svg className="hero-illustration hero-illustration-right" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="100" r="70" fill="rgba(255,255,255,0.08)" />
        <path d="M100,50 L100,150 M50,100 L150,100" stroke="rgba(255,255,255,0.15)" strokeWidth="3" strokeLinecap="round" />
        <circle cx="100" cy="50" r="8" fill="rgba(255,255,255,0.2)" />
        <circle cx="150" cy="100" r="8" fill="rgba(255,255,255,0.2)" />
        <circle cx="100" cy="150" r="8" fill="rgba(255,255,255,0.2)" />
        <circle cx="50" cy="100" r="8" fill="rgba(255,255,255,0.2)" />
      </svg>

      <div className="hero-content">
        <svg className="health-icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <path d="M50,25 C40,25 35,30 35,40 C35,55 50,65 50,75 C50,65 65,55 65,40 C65,30 60,25 50,25 Z"
                fill="rgba(255,255,255,0.9)" />
          <circle cx="50" cy="50" r="35" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="2" strokeDasharray="5,5" />
        </svg>

        <h1 className="hero-title">HashFusion Innovations</h1>
        <h2 className="hero-headline">Where Health, Technology, and Innovation Converge</h2>
        <p className="hero-subtext">
          HashFusion Innovations is a parent company focused on building products, platforms,
          and businesses that improve human health and wellbeing — blending technology, science,
          and thoughtful design.
        </p>
        <div className="cta-buttons">
          <button className="cta-button secondary" onClick={() => scrollToSection('our-vision')}>
            Explore Our Vision
          </button>
          <button className="cta-button secondary" onClick={() => scrollToSection('contact')}>
            Get in Touch
          </button>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
